import React, { useEffect } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

/**
 * Fullscreen lightbox for viewing a badge photo without leaving the admin
 * panel. Closes on backdrop click, ESC key, or the X button. Uses the admin's
 * JWT cookie automatically for `/api/files/private/...` URLs.
 */
export const BadgePhotoModal = ({ src, name, onClose }) => {
  useEffect(() => {
    if (!src) return undefined;
    const handleEsc = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", handleEsc);
    // Prevent body scroll while modal is open
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleEsc);
      document.body.style.overflow = prevOverflow;
    };
  }, [src, onClose]);

  if (!src) return null;
  const fullUrl = src.startsWith("http") ? src : `${BACKEND_URL}${src}`;

  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-[9999] bg-black/85 backdrop-blur-sm flex items-center justify-center p-4 animate-in fade-in duration-150"
      onClick={onClose}
      data-testid="badge-photo-modal"
    >
      <button
        onClick={onClose}
        className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center text-2xl transition-colors"
        aria-label="Mbyll"
        data-testid="badge-modal-close"
      >
        ×
      </button>
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative max-w-[90vw] max-h-[90vh] flex flex-col items-center gap-3"
      >
        <img
          src={fullUrl}
          alt={name ? `Badge - ${name}` : "Badge"}
          className="max-w-full max-h-[80vh] rounded-xl shadow-2xl object-contain bg-white"
        />
        {name && (
          <p className="text-white/90 text-sm font-medium bg-black/40 px-4 py-1.5 rounded-full">
            {name}
          </p>
        )}
      </div>
    </div>
  );
};

export default BadgePhotoModal;
